<template>
    <TheHeader></TheHeader>

    <div class="container-fluid">
        <div class="container">
            <form name="form">
                <div class="contain row">
                    <TheSidebar></TheSidebar>

                    <ThePageLoading v-if="isPageLoading"></ThePageLoading>

                    <div class="page-container card col-md-8" v-if="!isPageLoading">
                        <ThePageHeader></ThePageHeader>
                        <div class="row" v-if="pageError == ''">
                            <div class="col-md-12 p-4">
                                <div class="row mb-3">
                                    <div class="col-md-6">
                                        <Dropdown :options="companyReportTypes" optionLabel="name" optionValue="value" filter showClear placeholder="Type" v-model="companyReportDetailsFilter.typeFilter" @change="filterCompanyReportDetail" />
                                    </div>

                                    <div class="col-md-6">
                                        <MultiSelect :options="companyReportLoadStatuses" optionLabel="name" optionValue="value" filter placeholder="Status" v-model="companyReportDetailsFilter.statusFilter" display="chip" @change="filterCompanyReportDetail" />
                                    </div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-md-2 d-flex align-items-center">
                                        <Button class="p-button-sm p-button-warning" @click="clear" label="Clear" />
                                        <span class="p-1"></span>
                                        <Button class="p-button-sm p-button-secondary" @click="back" label="Back" />
                                    </div>

                                    <div class="d-flex col-md-10 justify-content-end">
										<span class="p-2" v-if="(isCompanyDetailProcessing || isCompanyReportLoading) && remainingLoadCount > 0">
											{{ "Remaining file(s): " + remainingLoadCount }}
										</span>

                                        <span class="p-2" v-if="(isCompanyDetailProcessing || isCompanyReportLoading) && remainingLoadCount == 0 || isImporting || isExporting">
											{{ "Processing" }} 
										</span>

                                        <TheLoading v-if="isCompanyDetailProcessing || isCompanyReportLoading || isImporting || isExporting"></TheLoading>
                                        <Button class="p-button-sm p-button-danger me-2" :disabled="isCompanyDetailProcessing || isCompanyReportLoading || companyReport.status == 'Finalised'" @click="resetAllCompanyReports()" label="Restructure" v-if="isAdmin || isHQStaff" :hidden="isViewer" v-tooltip.top="'Reset the CWK to apply new Conso Group changes and unlink its data so it can be deleted.'" />
                                        <Button class="p-button-sm p-button-danger me-2" :disabled="isCompanyDetailProcessing || isCompanyReportLoading || selectedDetails.length == 0" @click="resetCompanyReports" label="Unload" :hidden="isViewer" v-tooltip.top="'Remove the loaded data and unlink it so it can be deleted.'" />
                                        <Button class="p-button-sm p-button-warning me-2" :disabled="isCompanyDetailProcessing || isCompanyReportLoading || selectedDetails.length == 0" @click="retranslate" label="Re-translate" :hidden="isViewer" v-tooltip.top="'For different-currency items only: reset and reload the data using the latest exchange rate.'" />
                                        <Button class="p-button-sm p-button-warning me-2" :disabled="isCompanyDetailProcessing || isCompanyReportLoading || selectedDetails.length == 0" @click="loadCompanyReports(true)" label="Update Local Sheet" :hidden="isViewer" v-tooltip.top="'For different-currency items only: finalise the exchange-rate data in the foreign sheet and carry it forward to the local sheet.'" />
                                        <Button class="p-button-sm p-button-success me" :disabled="isCompanyDetailProcessing || isCompanyReportLoading || selectedDetails.length == 0" @click="loadCompanyReports(false)" label="Load" :hidden="isViewer" v-tooltip.top="'Load data from RPK, CWK (child/subsidiary) and Journal for consolidation.'" />
                                    </div>
                                </div>

                                <!-- <div class="row my-0 py-0">
									<div class="col-12" >
										<ProgressBar mode="indeterminate" style="height: 6px" v-if="!isCompanyDetailProcessing"></ProgressBar>
										<ProgressBar :value="loadProgress" mode="determinate" style="height: 6px" v-else></ProgressBar>
									</div>
								</div> -->

                                <DataTable :value="filteredCompanyReportDetails" paginator :rows="10" paginatorPosition="top">
                                    <Column style="width: 3%">
                                        <template #header>
                                            <Checkbox :modelValue="isAllDetailsSelected" :binary="true" :disabled="isCompanyDetailProcessing || isCompanyReportLoading || companyReport.status == 'Finalised'" @change="selectAllDetails"></Checkbox>
                                        </template>
                                        <template #body="slotProps">
                                            <Checkbox v-model="slotProps.data.isSelected" :binary="true" :disabled="slotProps.data.referenceFileId == '' || slotProps.data.referenceFileId == null || isCompanyDetailProcessing || isCompanyReportLoading || companyReport.status == 'Finalised'" @change="selectDetail(slotProps.data)"></Checkbox>
                                        </template>
                                    </Column>
                                    <Column style="width: 3%" header="#">
                                        <template #body="slotProps">
                                            {{ slotProps.index + 1 }}
                                        </template>
                                    </Column>
                                    <Column style="width: 6%" field="referenceType" header="Type"></Column>
                                    <Column style="width: 35%" field="referenceName" header="Name"></Column>
                                    <Column style="width: 20%" field="referenceFileId" header="File ID"></Column>
                                    <Column style="width: 10%">
                                        <template #body="slotProps">
                                            <div class="d-flex justify-content-center" v-if="!isViewer && slotProps.data.currencyId != null && slotProps.data.currencyId != companyReport.currency.identifier">

                                                <Button class="p-button-sm" icon="pi pi-download" :disabled="isCompanyDetailProcessing || isCompanyReportLoading || companyReport.status == 'Finalised'" v-if="slotProps.data.status == 'Pending Translated' || slotProps.data.status == 'Completed'" v-tooltip.top="'Import FX Rate Amount'" @click="importForeign($event, slotProps.data)" severity="secondary" text rounded>
                                                </Button>
                                                <input type="file" :id="'custom-file-upload-' + slotProps.data.identifier" hidden @change="importForeign($event, slotProps.data)" />

                                                <!-- <FileUpload class="p-button-sm" mode="basic" :customUpload="true" :auto="true" @uploader="importForeign($event,slotProps.data)" /> -->
                                                <Button class="p-button-sm" icon="pi pi-external-link" :disabled="isCompanyDetailProcessing || isCompanyReportLoading" v-if="slotProps.data.status == 'Pending Translated' || slotProps.data.status == 'Completed'" v-tooltip.top="'Export FX Rate Amount'" @click="exportForeign(slotProps.data)" severity="secondary" text rounded />
                                            </div>
                                        </template>
                                    </Column>
                                    <Column style="width: 5%" field="status">
                                        <template #header>
                                            <span>Status</span>
                                            <Button class="p-button-sm p-button-text" style="padding: 0px" icon="pi pi-refresh" v-if="isForceResetButtonVisible && isAdmin" @click="forceResetCompanyReports" v-tooltip.top="'Force Reset Processing Reports'" />
                                        </template>
                                        <template #body="slotProps">
                                            <div class="d-flex justify-content-center">
                                                <i class="pi pi-clock" :style="{color: 'var(--primary-color)'}" v-if="slotProps.data.status == 'Pending' " v-tooltip.top="slotProps.data.status" />
                                                <i class="pi pi-file-import" :style="{color: 'var(--primary-color)'}" v-if="slotProps.data.status == 'Pending Translated' " v-tooltip.top="slotProps.data.status" />
                                                <ProgressSpinner style="width: 1.5rem; height: 1.5rem" strokeWidth="5" v-else-if="slotProps.data.status == 'Processing'" v-tooltip.top="slotProps.data.status" />
                                                <i class="pi pi-check" :style="{color: 'var(--primary-color)'}" v-else-if="slotProps.data.status == 'Completed'" v-tooltip.top="slotProps.data.status" />
                                                <i class="pi pi-exclamation-circle" :style="{color: 'var(--bs-danger)'}" v-else-if="slotProps.data.status == 'Error'" v-tooltip.top="slotProps.data.status" />
                                            </div>
                                        </template>
                                    </Column>
                                    <Column style="width: 18%" field="statusDate" header="Status Date"></Column>

                                    <template #empty>
                                        <div v-if="isLoading">
                                            <TheLoading v-if="isLoading"></TheLoading>
                                        </div>
                                        <div class="error-no-record mt-3" v-else>
                                            <FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
                                            <h6><span>No Record Found</span></h6>
                                        </div>
                                    </template>
                                </DataTable>

                                <div class="row p-3">
                                    <div class="col-md-3"></div>

                                    <div class="d-flex col-md-4"></div>

                                    <div class="d-flex col-md-5 justify-content-end">
                                        <!-- <Button class="p-button-sm p-button-warning" :disabled="isLoading || isCompanyDetailProcessing || isCompanyReportLoading || isCalculating || !hasCompanyDetailCompleted || companyReport.status == 'Finalised'" @click="calculate(1, true, false)" label="Calculate" v-if="identifier != null" /> -->
                                        <SplitButton class="p-button-sm p-button-warning" :disabled="isLoading || isCompanyDetailProcessing || isCompanyReportLoading || isCalculating || !hasCompanyDetailCompleted || companyReport.status == 'Finalised'" :hidden="isViewer" @click="calculate(1, false)" label="Calculate" :model="calculateSplitButtonItems" v-if="identifier != null" />
                                        <span class="p-1"></span>
                                        <SplitButton class="p-button-sm p-button-warning" :disabled="isLoading || isCompanyDetailProcessing || isCompanyReportLoading || isCalculating" @click="checkUnsaved(1)" label="Local" :model="localSplitButtonItems" v-if="identifier != null" />
                                        <span class="p-1"></span>
                                        <SplitButton class="p-button-sm p-button-warning" :disabled="isLoading || isCompanyDetailProcessing || isCompanyReportLoading || isCalculating" @click="checkUnsaved(2)" label="Foreign" :model="foreignSplitButtonItems" v-if="identifier != null" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <TheSheetsDialog :identifier="dialog.identifier" :name="dialog.fileId" :type="'cwk'" :balanceSheetDate="dialog.balanceSheetDate == null ? null : formatToDate(dialog.balanceSheetDate)" :currencyCode="dialog.currencyCode" :purpose="dialog.purpose" :id="dialog.id" :templateIndex="dialog.templateIndex" :status="dialog.status" :visible="dialog.visible" :loading="dialog.loading" :isUnsaved="dialog.isUnsaved" :reportSheets="dialog.companyReportSheets" @save="updateSheets" @autoSave="updateSheetCached" @deleteCached="deleteSheetCached" @cancel="closeDialog"></TheSheetsDialog>

                        <ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
                    </div>

                    <TheFooter></TheFooter>
                </div>
            </form>
        </div>
    </div>

    <Dialog v-model:visible="isShowUnsavedConfirmation" header="Recover Unsaved Changes" modal :style="{ width: '40vw' }">
		<p v-if="isViewer">
            Any data entered by you (as a viewer) will not be saved or processed
        </p>
        <p v-else>
            Unsaved changes detected and available to recovery. Would you like to recover these changes now?
        </p>

        <template #footer>
            <Button label="No" icon="pi pi-times" @click="sheets(dialog.templateIndex, false, null)" text />
            <Button label="Yes" icon="pi pi-check" @click="sheets(dialog.templateIndex, true, null)" :hidden="isViewer" />
        </template>
    </Dialog>

    <Dialog v-model:visible="isCalculating" header="Calculating" modal :style="{ width: '40vw' }" :closable="false">
        <p>
            The system is calculating, please do not refresh the page or close the window while calculating.
        </p>

        <template #footer>
            <TheLoading v-if="isCalculating"></TheLoading>
        </template>
    </Dialog>

    <TheSheetsCommentsDialog ref="sheetsCommentsDialog"></TheSheetsCommentsDialog>
</template>

<script lang="ts">
    import { defineComponent } from "vue";
    import { useRoute } from "vue-router";
    import store from "@/store";
    import companyReportApi from "@/api/companyreport-api";
    import companyReportSheetApi from "@/api/companyreportsheet-api";
    import companyReportSheetTemplateApi from "@/api/companyreportsheettemplate-api";
    import journalApi from "@/api/journal-api";

    import dateUtilsMixin from "@/mixin/utils/date-utils";
    import formulaMixin from "@/mixin/formula";
    import companyReportTypeMixin from "@/mixin/company-report-type";
    import companyReportLoadStatusMixin from "@/mixin/company-report-load-status";
    import roleMixin from "@/mixin/role";

    import TheHeader from "@/components/TheHeader.vue";
    import TheFooter from "@/components/TheFooter.vue";
    import TheSidebar from "@/components/TheSidebar.vue";
    import ThePageHeader from "@/components/ThePageHeader.vue";
    import ThePageLoading from "@/components/ThePageLoading.vue";
    import TheLoading from "@/components/TheLoading.vue";
    import ThePageError from "@/components/ThePageError.vue";
    import TheSheetsDialog from "@/components/TheSheetsDialog.vue";
    import TheSheetsCommentsDialog from "@/components/TheSheetsCommentsDialog.vue";

    import useVuelidate from "@vuelidate/core";

    export default defineComponent({
        name: "CompanyReportCWKConfiguration",
        mixins: [dateUtilsMixin, formulaMixin, companyReportTypeMixin, companyReportLoadStatusMixin, roleMixin],
        components: {
            TheHeader,
            TheFooter,
            TheSidebar,
            ThePageHeader,
            ThePageLoading,
            TheLoading,
            ThePageError,
            TheSheetsDialog,
            TheSheetsCommentsDialog
        },
        data() {
            return {
                pageError: (store.getters.error == undefined ? '' : store.getters.error),
                identifier: useRoute().params.id,
                companies: [] as any[],
                isPageLoading: false,
                isLoading: false,
                isImporting: false,
                isExporting: false,
                isCompanyReportLoading: false,
                loadCompanyReportInterval: 0,
                companyReportSheets: [] as any[],
                companyReport: {identifier: null, fileId: null, consoGroup: {identifier: null, name: ''} as any, balanceSheetDate: null as any, currency: {identifier: null, code: ''}, purpose: {identifier: null, name: ''}, isConsolidated: false, id: 0.0, status: '', isCalculated: false, companyReportDetails: [] as any[], isClosed: false},
                companyReportDetail: {identifier: null, referenceId: null, referenceType: '', referenceCode: '', referenceName: '', referenceFileId: null, status: '', statusDate: '', currencyId: null, remarks: null},
                companyReportDetails: [] as any[],
                companyReportDetailsFilter: {typeFilter: null, statusFilter: [] as any[]},
                filteredCompanyReportDetails: [] as any[],
                selectedDetails: [] as any[],
                isAllDetailsSelected: false,
                dialog: {identifier: null, groupName: null as any, fileId: null as any, balanceSheetDate: null as any, currencyCode: null as any, purpose: null as any, id: 0.0, templateIndex: 0, status: '', visible: false, loading: false, isUnsaved: false, companyReportSheets: null as any},
                isShowUnsavedConfirmation: false,
                unsavedId: 0.0,
                isCalculating: false,
                remainingLoadCount: 0,
                isForceResetButtonVisible: false,
            };
        },
        mounted: function () {
            if (this.pageError == '') {
                this.isPageLoading = true;
                this.loadTable();
            }
        },
        computed: {
            isCompanyDetailProcessing() {
                return (this.companyReport.companyReportDetails.find((detail: any) => detail.status == 'Processing') != null);
            },
            isCompanyDetailLoaded() {
                return (this.companyReport.companyReportDetails.find((detail: any) => detail.status == 'Error' || detail.status == 'Completed') != null);
            },
            hasCompanyDetailCompleted() {
                return (this.companyReport.companyReportDetails.find((detail: any) => detail.status == 'Completed') != null);
            },
            calculateSplitButtonItems() {
                // Main button calculates template 1 (local sheet); this dropdown recomputes template 2
                // (foreign sheet) on the backend (authoritative), not client-side - see calculateForeign().
                return [
                    {
                        label: 'Calculate Foreign Sheet',
                        command: () => this.calculateForeign()
                    }
                ];
            },
            localSplitButtonItems() {
                return [
                    {
                        label: 'Comments',
                        command: this.showLocalSheetsCommentsDialog
                    }
                ];
            },
            foreignSplitButtonItems() {
                return [
                    {
                        label: 'Comments',
                        command: this.showForeignSheetsCommentsDialog
                    }
                ];
            }
        },
        methods: {
            loadTable() {
                this.isLoading = true;
                this.isAllDetailsSelected = false;
                this.selectedDetails = [] as any[];
                this.companyReportDetails = [] as any[];
                companyReportApi.companyReportView(this.identifier, 'cwk')
                    .then((response: any) => {
                        this.companyReport = response.data.companyReport;

                        let r1 = companyReportApi.companyReportListByConsoGroupNameDate({company: this.companyReport.identifier, consoGroup: this.companyReport.consoGroup, balanceSheetDate: this.companyReport.balanceSheetDate});
                        let r2 = journalApi.journalListByConsoGroupNameDate({consoGroup: this.companyReport.consoGroup, balanceSheetDate: this.companyReport.balanceSheetDate});

                        Promise.all([r1, r2])
                            .then((values: any) => {
                                if (values != null) {
                                    for (var i = 0; i < values.length; i++) {
                                        if (values[i] != null) {
                                            if (values[i].success) {
                                                if (values[i].data != null) {
                                                    if (i == 0) {
                                                        values[i].data.listSet.forEach((detail: any) => {
                                                            this.companyReportDetail = {identifier: null, referenceId: detail.identifier, referenceType: detail.type, referenceCode: detail.companyCode, referenceName: detail.type == 'RPK' ? detail.companyName : detail.consoGroupName, referenceFileId: detail.fileId, status: '', statusDate: '', currencyId: detail.currencyId, remarks: null};

                                                            var companyReportDetailsIndex = this.companyReport.companyReportDetails.findIndex((companyReportDetail: any) => companyReportDetail.referenceFileId == detail.fileId);
                                                            if (companyReportDetailsIndex != -1) {
                                                                this.companyReportDetail.identifier = this.companyReport.companyReportDetails[companyReportDetailsIndex].identifier;
                                                                this.companyReportDetail.status = this.companyReport.companyReportDetails[companyReportDetailsIndex].status;

                                                                if (this.companyReportDetail.status == 'Pending Translated' || this.companyReportDetail.status == 'Completed') {
                                                                    this.companyReportDetail.statusDate = this.formatToDateTime(this.companyReport.companyReportDetails[companyReportDetailsIndex].lastModifiedDate);
                                                                }
                                                            }

                                                            else {
                                                                if (detail.fileId != null && detail.fileId != '') {
                                                                    this.companyReportDetail.status = 'Pending';
                                                                }
                                                            }
                                                            if (detail.type == 'CWK' || !detail.isVirtual) {
                                                                this.companyReportDetails.push(this.companyReportDetail);
                                                            }
                                                        });

                                                        if (this.companyReportDetails.filter((companyReportDetail: any) => companyReportDetail.status == 'Processing').length > 0) {
                                                            this.isForceResetButtonVisible = true;
                                                        }                                                            
                                                    }

                                                    else if (i == 1) {
                                                        values[i].data.listSet.forEach((detail: any) => {
                                                            this.companyReportDetail = {identifier: null, referenceId: detail.identifier, referenceType: 'Journal', referenceCode: detail.companyCode, referenceName: detail.consoGroupName, referenceFileId: detail.fileId, status: '', statusDate: '', currencyId: detail.currencyId, remarks: null};

                                                            var companyReportDetailsIndex = this.companyReport.companyReportDetails.findIndex((companyReportDetail: any) => companyReportDetail.referenceFileId == detail.fileId);
                                                            if (companyReportDetailsIndex != -1) {
                                                                this.companyReportDetail.identifier = this.companyReport.companyReportDetails[companyReportDetailsIndex].identifier;
                                                                this.companyReportDetail.status = this.companyReport.companyReportDetails[companyReportDetailsIndex].status;
                                                                if (this.companyReportDetail.status == 'Completed') {
                                                                    this.companyReportDetail.statusDate = this.formatToDateTime(this.companyReport.companyReportDetails[companyReportDetailsIndex].lastModifiedDate);
                                                                }
                                                            }

                                                            else {
                                                                this.companyReportDetail.status = 'Pending';
                                                            }
                                                            this.companyReportDetails.push(this.companyReportDetail);
                                                        });
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }

                                this.companyReportDetails.forEach((companyReportDetail: any) => {
                                    if (companyReportDetail.status == 'Processing') {
                                        this.remainingLoadCount += 1;
                                    }
                                });

                                this.isLoading = false;
                                this.isPageLoading = false;
                                this.filteredCompanyReportDetails = [] as any[];
                                this.filteredCompanyReportDetails = this.companyReportDetails;

                                if (this.remainingLoadCount > 0) {
                                    this.loadCompanyReportInterval = setInterval(this.checkCompanyReportLoadedStatus, 5000);
                                }

                            })
                            .catch((error: any) => {
                                this.isLoading = false;
                                console.log(error);
                            });

                    })
                    .catch(error => {
                        this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                    });
            },
            filterCompanyReportDetail() {
                if (this.companyReportDetailsFilter.typeFilter != null) {
                    this.filteredCompanyReportDetails = this.companyReportDetails.filter((detail: any) => {
                        if (detail.referenceType == this.companyReportDetailsFilter.typeFilter) {
                            return detail;
                        }
                    });
                }

                else {
                    this.filteredCompanyReportDetails = this.companyReportDetails;
                }

                if (this.companyReportDetailsFilter.statusFilter != null && this.companyReportDetailsFilter.statusFilter.length > 0) {
                    this.filteredCompanyReportDetails = this.filteredCompanyReportDetails.filter((detail: any) => {
                        for (var i = 0; i < this.companyReportDetailsFilter.statusFilter.length; i++) {
                            if (detail.status == this.companyReportDetailsFilter.statusFilter[i]) {
                                return detail;
                            }
                        }
                    });
                }
            },
            clear() {
                this.companyReportDetailsFilter.typeFilter = null;
                this.companyReportDetailsFilter.statusFilter = [] as any[];
                this.filteredCompanyReportDetails = this.companyReportDetails;
            },
            back() {
                this.$router.push("/companyreport/cwk/view/" + this.companyReport.identifier);
            },
            loadCompanyReports(isTranslate: any) {
                this.isCompanyReportLoading = true;

                var selectedDetails = [] as any[];
                this.selectedDetails.forEach((detail: any) => {
                    if ((detail.status == "Pending" && !isTranslate) || (detail.status == "Pending Translated" && isTranslate) || (detail.status == "Error" && !isTranslate) || (detail.status == "Completed" && detail.currencyId != this.companyReport.currency.identifier && isTranslate && detail.referenceType != "Journal")) {
                        selectedDetails.push(detail);
                    }
                });

                if (selectedDetails.length > 0) {
                    this.remainingLoadCount = selectedDetails.length;
                    companyReportApi.companyReportLoad({companyReport: this.companyReport, selectedDetails: selectedDetails}, 'cwk')
                        .then((response: any) => {
                            this.filteredCompanyReportDetails.forEach((companyReportDetail) => companyReportDetail.isSelected = false);
                            this.isAllDetailsSelected = false;
                            this.$toast.add({severity: "success", summary: "", detail: response.message, life: 6000});

                            this.checkCompanyReportLoadedStatus();
                            this.loadCompanyReportInterval = setInterval(this.checkCompanyReportLoadedStatus, 5000);
                        })
                        .catch(error => {
                            this.isCompanyReportLoading = false;
                            this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                        });
                }

                else {
                    this.isCompanyReportLoading = false;
                    if (isTranslate) {
                        this.$toast.add({severity: "error", summary: "Error", detail: "Selected company report(s) cannot be translated", life: 6000});
                    }

                    else {
                        this.$toast.add({severity: "error", summary: "Error", detail: "Selected company report(s) are already loaded", life: 6000});
                    }
                }
            },
            resetCompanyReports() {
                this.$confirm.require({
                    header: 'Confirmation',
                    message: 'Are you sure you want to reset loaded company report(s)?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.isCompanyReportLoading = true;

                        var selectedDetails = [] as any[];
                        var exportPromises = [] as any[];
                        this.selectedDetails.forEach((detail: any) => {
                            if (detail.status == "Completed" || detail.status == "Pending Translated" || detail.status == "Error") {
                                selectedDetails.push(detail);
                                // check if fx then call export here
                                if (this.companyReport.currency.identifier != detail.currencyId && detail.referenceType != "Journal") {
                                    exportPromises.push(this.exportForeign(detail, "UNLD"));
                                }
                            }
                        });

                        if (selectedDetails.length > 0) {
                            this.remainingLoadCount = selectedDetails.length;
                            // Wait for the FX exports to finish reading the data before the reset removes it,
                            // otherwise the export races the unload and fails with "data not found".
                            Promise.allSettled(exportPromises)
                                .then(() => companyReportApi.companyReportReset({companyReport: this.companyReport, selectedDetails: selectedDetails}, 'cwk'))
                                .then((response: any) => {
                                    this.$toast.add({severity: "success", summary: "", detail: response.message, life: 6000});
                                    this.filteredCompanyReportDetails.forEach((companyReportDetail: any) => { companyReportDetail.isSelected = false; });
                                    this.isAllDetailsSelected = false;

                                    this.checkCompanyReportLoadedStatus();
                                    this.loadCompanyReportInterval = setInterval(this.checkCompanyReportLoadedStatus, 5000);
                                })
                                .catch(error => {
                                    this.isCompanyReportLoading = false;
                                    this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                                });
                        }

                        else {
                            this.isCompanyReportLoading = false;
                            this.$toast.add({severity: "error", summary: "Error", detail: "Selected company report(s) are already unloaded", life: 6000});
                        }
                    }
                });
            },
            forceResetCompanyReports() {
                this.$confirm.require({
                    header: 'Confirmation',
                    message: 'Are you sure you want to forcibly reset processing company report(s)? This may interfere with active processing.',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.isCompanyReportLoading = true;

                        var processingDetails = [] as any[];
                        this.companyReportDetails.forEach((detail: any) => {
                            if (detail.status == "Processing") {
                                processingDetails.push(detail);
                            }
                        });

                        if (processingDetails.length > 0) {
                            this.remainingLoadCount = processingDetails.length;
                            companyReportApi.companyReportReset({companyReport: this.companyReport, selectedDetails: processingDetails}, 'cwk')
                                .then((response: any) => {
                                    this.$toast.add({severity: "success", summary: "", detail: response.message, life: 6000});
                                    this.filteredCompanyReportDetails.forEach((companyReportDetail) => companyReportDetail.isSelected = false);
                                    this.isAllDetailsSelected = false;
                                    // Restart polling so the UI reflects the reset and clears the spinner,
                                    // even if a previous interval was stopped/lost.
                                    clearInterval(this.loadCompanyReportInterval);
                                    this.checkCompanyReportLoadedStatus();
                                    this.loadCompanyReportInterval = setInterval(this.checkCompanyReportLoadedStatus, 5000);
                                })
                                .catch(error => {
                                    this.isCompanyReportLoading = false;
                                    this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                                });
                        }

                        else {
                            // Nothing is actually processing locally — clear the stuck spinner instead of hanging.
                            this.isCompanyReportLoading = false;
                            this.remainingLoadCount = 0;
                            this.isForceResetButtonVisible = false;
                            this.$toast.add({severity: "warn", summary: "", detail: "No processing company report(s) to reset.", life: 6000});
                        }
                    }
                });
            },
            retranslate() {
                this.isCompanyReportLoading = true;

                var selectedDetails = [] as any[];
                this.selectedDetails.forEach((detail: any) => {
                    if ((detail.status == "Completed" || detail.status == "Pending Translated") && detail.currencyId != this.companyReport.currency.identifier && detail.referenceType != "Journal") {
                        selectedDetails.push(detail);
                    }
                });

                if (selectedDetails.length > 0) {
                    this.remainingLoadCount = selectedDetails.length;
                    companyReportApi.companyReportRetranslate({companyReport: this.companyReport, selectedDetails: selectedDetails}, 'cwk')
                        .then((response: any) => {
                            this.$toast.add({severity: "success", summary: "", detail: response.message, life: 6000});
                            this.filteredCompanyReportDetails.forEach((companyReportDetail) => companyReportDetail.isSelected = false);
                            this.isAllDetailsSelected = false;
                            this.checkCompanyReportLoadedStatus();
                            this.loadCompanyReportInterval = setInterval(this.checkCompanyReportLoadedStatus, 5000);
                        })
                        .catch(error => {
                            this.isCompanyReportLoading = false;
                            this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                        });
                }

                else {
                    this.isCompanyReportLoading = false;
                    this.$toast.add({severity: "error", summary: "Error", detail: "Selected company report(s) cannot be retranslated", life: 6000});
                }
            },
            resetAllCompanyReports() {
                this.$confirm.require({
                    header: 'Confirmation',
                    message: 'Are you sure you want to restructure loaded company report(s)?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.isCompanyReportLoading = true;
                        companyReportApi.companyReportResetAll({companyReport: this.companyReport}, 'cwk')
                            .then((response: any) => {
                                this.isCompanyReportLoading = false;
                                this.$toast.add({severity: "success", summary: "", detail: response.message, life: 6000});
                                this.filteredCompanyReportDetails.forEach((companyReportDetail) => companyReportDetail.isSelected = false);
                                this.isAllDetailsSelected = false;

                                this.filteredCompanyReportDetails.forEach((companyReportDetail: any) => {
                                    if (companyReportDetail.referenceId != null) {
                                        companyReportDetail.status = 'Pending';
                                    }
                                });

                                this.selectedDetails = [];
                                this.loadTable();
                            })
                            .catch(error => {
                                this.isCompanyReportLoading = false;
                                this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                            });
                    }
                });
            },
            checkCompanyReportLoadedStatus() {
                companyReportApi.companyReportCheck(this.identifier, 'cwk')
                    .then((value: any) => {
                        this.companyReport = value.data.companyReport;

                        let count = 0;
                        this.companyReport.companyReportDetails.forEach((detail: any) => {
                            let index = this.filteredCompanyReportDetails.findIndex((companyReportDetail: any) => {
                                return ((detail.referenceType == companyReportDetail.referenceType) && (detail.referenceId == companyReportDetail.referenceId));
                            });
                            if (index != -1) {
                                this.filteredCompanyReportDetails[index].status = detail.status;
                                if (this.filteredCompanyReportDetails[index].status != 'Processing') {
                                    this.filteredCompanyReportDetails[index].identifier = detail.identifier;
                                    if (this.filteredCompanyReportDetails[index].status == 'Pending') {
                                        this.filteredCompanyReportDetails[index].statusDate = '';
                                    }

                                    else {
                                        this.filteredCompanyReportDetails[index].statusDate = detail.lastModifiedDate;
                                    }
                                }
                                else {
                                    count++;
                                }
                            }
                        });
                        this.filteredCompanyReportDetails.forEach((companyReportDetail: any) => {
                            if (companyReportDetail.referenceFileId != null) {
                                let itemDetail = this.companyReport.companyReportDetails.find((d: any) => {
                                    return ((d.referenceType == companyReportDetail.referenceType) && (d.referenceId == companyReportDetail.referenceId));
                                });
                                if (itemDetail == null) {
                                    // Detail was deleted on the backend (e.g. via unload/reset). Reflect as Pending in UI.
                                    companyReportDetail.identifier = null;
                                    companyReportDetail.status = 'Pending';
                                    companyReportDetail.statusDate = '';
                                }
                            }
                        });
                        this.remainingLoadCount = count;

                        if (!this.companyReport.companyReportDetails.find((companyReportDetail: any) => companyReportDetail.status == 'Processing')) {
                            this.isCompanyReportLoading = false;
                            clearInterval(this.loadCompanyReportInterval);
                            this.selectedDetails = [];
                            this.remainingLoadCount = 0;
                            if (!this.companyReport.isCalculated) {
                                // Only recompute the local sheet (template 1) on the client. The foreign
                                // sheet (template 2) is left as the backend computed it during load/re-translate:
                                // the backend re-evaluates every formula in sheet order, so cross-page foreign
                                // aggregates (e.g. Pg_117!D43 = sum of Pg_104..116!D41) are internally consistent.
                                // The client-side calculate(2) uses event-driven propagation that does NOT
                                // reliably refresh those cross-page totals, so running it here would overwrite
                                // the correct backend values with stale ones. Backend is authoritative for foreign.
                                this.calculate(1, false);
                            }
                            this.isForceResetButtonVisible = false;
                        }
                    })
                    .catch(error => {
                        clearInterval(this.loadCompanyReportInterval);
                        this.pageError = error;
                        this.isPageLoading = false;
                    });
            },
            selectAllDetails() {
                this.isAllDetailsSelected = !this.isAllDetailsSelected;

                this.selectedDetails = [] as any[];
                this.filteredCompanyReportDetails.forEach((companyReportDetail: any) => {
                    if (companyReportDetail.referenceFileId != null && companyReportDetail.referenceFileId != '') {
                        companyReportDetail.isSelected = this.isAllDetailsSelected;
                    }

                    if (companyReportDetail.isSelected) {
                        this.selectedDetails.push(companyReportDetail);
                    }
                });
            },
            selectDetail(detail: any) {
                var index = this.selectedDetails.findIndex((selectedDetail: any) => selectedDetail == detail);
                if (index != -1) {
                    this.selectedDetails.splice(index, 1);
                }

                else {
                    this.selectedDetails.push(detail);
                }

                if (this.selectedDetails != null && this.selectedDetails.length > 0 && this.companyReportDetails != null && this.companyReportDetails.length > 0) {
                    this.isAllDetailsSelected = (this.selectedDetails.length == this.companyReportDetails.filter((companyReportDetail: any) => companyReportDetail.status != null).length);
                }

                else {
                    this.isAllDetailsSelected = false;
                }
            },
            selectedDetailsHasStatus: function (status: any) {
                var selectedDetails = this.selectedDetails.filter(function (selectedDetail: any) {
                    if (selectedDetail.status == status) {
                        return selectedDetail;
                    }
                });
                if (selectedDetails != null && selectedDetails.length > 0) {
                    return true;
                }
                return false;
            },
            checkUnsaved(templateIndex: any) {
                companyReportApi.companyReportCheckUnsaved(this.identifier, 'cwk', templateIndex)
                    .then(response => {
                        this.unsavedId = response.data.unsavedId;
                        this.dialog.templateIndex = templateIndex;
                        response.data.hasUnsaved ? this.isShowUnsavedConfirmation = true : this.sheets(templateIndex, false, null);
                    })
                    .catch(error => {
                        this.isLoading = false;
                        this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                    });
            },
            // setCurrentPageIndex(event:any) {
            // 	this.currentPageIndexStart = event.first;
            // },
            sheets(templateIndex: any, getUnsaved: any, companyReportSheets: any) {
                getUnsaved ? this.dialog.isUnsaved = true : this.dialog.isUnsaved = false;
                this.isShowUnsavedConfirmation = false;

                this.dialog.identifier = this.companyReport.identifier;
                this.dialog.groupName = this.companyReport.consoGroup.name;
                this.dialog.fileId = this.companyReport.fileId;
                this.dialog.balanceSheetDate = this.companyReport.balanceSheetDate;
                this.dialog.currencyCode = this.companyReport.currency.code;
                this.dialog.purpose = this.companyReport.consoGroup.purpose.name;
                this.dialog.id = this.companyReport.id;
                this.dialog.templateIndex = templateIndex;
                this.dialog.isUnsaved ? this.dialog.id = this.unsavedId : this.dialog.id = this.companyReport.id;
                this.dialog.status = this.companyReport.status;
                this.dialog.companyReportSheets = companyReportSheets;
                this.dialog.visible = true;

                document.body.classList.add("dialog-open");
            },
            updateSheets(companyReportSheets: any, isCloseDialog: any, isNearestThousand: any, isUpdateLocalSheet: any) {
                this.dialog.loading = true;
                this.isCompanyReportLoading = true;

                let rs = [] as any[];

                companyReportSheets.forEach((companyReportSheet: any, index: any) => {
                    if (companyReportSheet.sheetError == '') {
                        let r = companyReportSheetApi.companyReportSheetUpdate({identifier: this.identifier, companyReportSheet: {identifier: companyReportSheet.identifier, sheet: companyReportSheet.sheet, content: {template: companyReportSheet.template}}}, this.dialog.templateIndex)
                            .catch(error => {
                                this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                            });
                        rs.push(r);
                    }
                });

                if (!this.isCalculating) {
                    let r1 = companyReportApi.companyReportUpdateId({companyReport: this.companyReport}, 'cwk', this.dialog.templateIndex);
                    rs.push(r1);
                }

                Promise.all(rs)
                    .then((values: any) => {
                        if (values != null) {
                            for (var i = 0; i < values.length; i++) {
                                if (values[i] != null) {
                                    if (values[i].success) {
                                        if (values[i].data != null) {
                                            if (i == values.length - 1 && !this.isCalculating) {
                                                this.companyReport.id = values[i].data.companyReport.id;
                                                this.dialog.id = this.companyReport.id;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        this.dialog.loading = false;
                        this.isCompanyReportLoading = false;
                        if (isCloseDialog) {
                            this.closeDialog(true, null, null, null, null);
                        }
                        if (isUpdateLocalSheet) {
                            // The foreign sheet (template 2) was edited. The client-side propagation
                            // cannot reliably recompute cross-page foreign aggregates (e.g. Pg_26!D45
                            // via Pg_23), so recompute template 2 on the backend (authoritative) from
                            // the just-saved edits, then run the local translation pass.
                            this.isCompanyReportLoading = true;
                            companyReportApi.companyReportCalculateForeign({companyReport: this.companyReport}, 'cwk')
                                .then(() => {
                                    this.isAllDetailsSelected = false;
                                    this.selectAllDetails();
                                    this.loadCompanyReports(true);
                                })
                                .catch((error: any) => {
                                    this.isCompanyReportLoading = false;
                                    this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                                });
                        }
                    })
                    .catch(error => {
                        this.dialog.loading = false;
                        this.isCompanyReportLoading = false;
                        this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                    });
            },
            updateSheetCached(companyReportSheet: any, pageIndex: any, scrollTop: any, scrollLeft: any, lastAccessedCell: any) {
                var companyReportSheetCached = {identifier: null, sheet: {identifier: null}, content: {template: null}, pageIndex: 0, scrollDetail: {scrollTop: 0, scrollLeft: 0}, lastAccessedCell: null};
                companyReportSheetCached.identifier = companyReportSheet.identifier;
                companyReportSheetCached.sheet = companyReportSheet.sheet;
                companyReportSheetCached.content.template = companyReportSheet.template;
                companyReportSheetCached.pageIndex = pageIndex;
                companyReportSheetCached.scrollDetail.scrollTop = scrollTop;
                companyReportSheetCached.scrollDetail.scrollLeft = scrollLeft;
                companyReportSheetCached.lastAccessedCell = lastAccessedCell;

                companyReportSheetApi.companyReportSheetUpdateCached({identifier: this.identifier, companyReportSheet: companyReportSheetCached}, this.dialog.templateIndex)
                    .then(response => {
                        //
                    })
                    .catch(error => {
                        //
                    });
            },
            deleteSheetCached(companyReportSheet: any, pageIndex: any, scrollTop: any, scrollLeft: any, lastAccessedCell: any, isCloseDialog: any) {
                this.dialog.loading = true;

                var companyReportSheetCached = {identifier: null, pageIndex: 0, scrollDetail: {scrollTop: 0, scrollLeft: 0}, lastAccessedCell: null};
                companyReportSheetCached.identifier = companyReportSheet.identifier;
                companyReportSheetCached.pageIndex = pageIndex;
                companyReportSheetCached.scrollDetail.scrollTop = scrollTop;
                companyReportSheetCached.scrollDetail.scrollLeft = scrollLeft;
                companyReportSheetCached.lastAccessedCell = lastAccessedCell;

                companyReportSheetApi.companyReportSheetDeleteCached({identifier: this.identifier, companyReportSheet: companyReportSheetCached}, this.dialog.templateIndex)
                    .then(response => {
                        this.dialog.loading = false;

                        if (isCloseDialog) {
                            this.closeDialog(true, null, null, null, null);
                        }
                    })
                    .catch(error => {
                        this.dialog.loading = false;
                        this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                    });
            },
            closeDialog(hasCached: any, pageIndex: any, scrollTop: any, scrollLeft: any, lastAccessedCell: any) {
                if (!hasCached) {
                    var lastAccessedDetail = {pageIndex: 0, scrollDetail: {scrollTop: 0, scrollLeft: 0}, lastAccessedCell: null};
                    lastAccessedDetail.pageIndex = pageIndex;
                    lastAccessedDetail.scrollDetail.scrollTop = scrollTop;
                    lastAccessedDetail.scrollDetail.scrollLeft = scrollLeft;
                    lastAccessedDetail.lastAccessedCell = lastAccessedCell;

                    companyReportApi.companyReportLastAccess({identifier: this.identifier, lastAccessedDetail: lastAccessedDetail}, 'cwk', this.dialog.templateIndex)
                        .then(response => {
                            //
                        })
                        .catch(error => {
                            //
                        });
                }
                this.dialog.visible = false;
                document.body.classList.remove("dialog-open");
                this.loadTable();
            },
            // calculate(templateIndex: any, isCalculate: any, isFixedRate: any) {
            calculate(templateIndex: any, isFixedRate: any) {
                this.isCalculating = true;

                this.dialog.templateIndex = templateIndex;
                companyReportSheetApi.companyReportSheetViewByCompanyReportId(this.identifier, 'cwk', templateIndex)
                    .then(response => {
                        this.companyReportSheets = response.data.listSet;
                        let r = [] as any[];
                        this.companyReportSheets.forEach((companyReportSheet: any, index: any) => {
                            companyReportSheet.isLoading = true;
                            companyReportSheet.sheetError = '';
                            r.push(companyReportSheetTemplateApi.companyReportSheetTemplateViewByCompanyReportSheet(templateIndex, companyReportSheet.identifier, {identifier: this.identifier, isUnsaved: false})
                                .catch(error => {
                                    companyReportSheet.isLoading = false;
                                    companyReportSheet.sheetError = error;
                                }));
                        });

                        Promise.all(r)
                            .then((values: any) => {
                                if (values != null) {
                                    for (var i = 0; i < values.length; i++) {
                                        if (values[i] != null && values[i].data != null) {
                                            this.companyReportSheets[i].template = values[i].data.content.template;

                                            this.companyReportSheets[i].navigateChilds = [];
                                            if (values[i].data.function != null && values[i].data.function.navigateChilds != null) {
                                                this.companyReportSheets[i].navigateChilds = values[i].data.function.navigateChilds;
                                                if (i == 1) {
                                                    this.companyReportSheets[i].navigateChilds.push(87);
                                                }
                                            }

                                            this.setComponents(this.companyReportSheets, i, false);
                                        }
                                    }

                                    for (var j = 0; j < values.length; j++) {
                                        if (values[j] != null && values[j].data != null) {
                                            this.setValues(this.companyReportSheets, j, 'cwk', isFixedRate);
                                        }
                                    }

                                    if (templateIndex == 2) {
                                        // this.isCalculating = false;

                                        // if (isCalculate) {
                                        // 	this.calculate(1, true, false);
                                        // 	this.sheets(1, false, this.companyReportSheets);
                                        // }

                                        // else {
                                        this.dialog.templateIndex = 2;
                                        // this.updateSheets(this.companyReportSheets, false);
                                        // }
                                    }

                                    else {
                                        // this.isCalculating = false;
                                        this.dialog.templateIndex = 1;
                                        // this.updateSheets(this.companyReportSheets, false);
                                    }

                                    this.isCalculating = false;
                                    this.updateSheets(this.companyReportSheets, false, false, false);
                                }
                            })
                            .catch(error => {
                                this.isCalculating = false;
                            });
                    })
                    .catch((error: any) => {
                        this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                        this.isCalculating = false;
                    });
            },
            calculateForeign() {
                // Recompute the foreign sheet (template 2) on the backend, which is authoritative for it.
                // The backend re-evaluates every foreign formula in sheet order so cross-page aggregates
                // (e.g. Pg_117!D43) stay consistent; the previous client-side calculate(2) could not
                // reliably refresh those totals. Afterwards just refresh the table from the backend.
                this.isCalculating = true;
                companyReportApi.companyReportCalculateForeign({companyReport: this.companyReport}, 'cwk')
                    .then((response: any) => {
                        this.isCalculating = false;
                        this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
                        this.loadTable();
                    })
                    .catch((error: any) => {
                        this.isCalculating = false;
                        this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                    });
            },
            importForeign(event: any, data: any) {
                var upload = document.getElementById('custom-file-upload-'+data.identifier);
                upload?.click();

                if (event.target.files != null && event.target.files.length > 0) {
                    this.isExporting = true;

                    companyReportApi.companyReportExport({identifier: this.identifier, templateIndex: 2, actionType: "backup", backupAction: "IMPF"}, 'cwk')
                        .then(response => {
                            this.isExporting = false;
                            this.isImporting = true;
                            var formData = new FormData();
                            formData.append('file', event.target.files[0]);
                            formData.append('identifier', this.identifier.toString());
                            formData.append('templateIndex', '2');
                            formData.append('companyReportDetailId', data.identifier);

                            companyReportApi.companyReportImportForeign(formData, 'cwk')
                                .then((response: any) => {
                                    this.isImporting = false;
                                    event.target.value = null;
                                    this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
                                    // The backend already recomputed the foreign template (and, for a
                                    // Completed detail, the local template) from the imported FX amounts.
                                    // Just reload the table so statuses/values refresh from the backend -
                                    // do NOT run the client-side calculate(2), which recomputes the foreign
                                    // sheet by event-propagation and would overwrite the correct backend
                                    // cross-page aggregates (e.g. Pg_117!D43) with stale values.
                                    this.loadTable();
                                })
                                .catch(error => {
                                    this.isImporting = false;
                                    this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                                });
                        })
                        .catch(error => {
                            this.isImporting = false;
                            this.isExporting = false;
                            this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                        });
                }
            },
            exportForeign(companyReport: any, backupAction: string | null = null) {
                this.isExporting = true;
                const request = {identifier: this.identifier, templateIndex: 2, referenceCode: companyReport.referenceCode} as any;
                // When invoked as part of an unload/reset, tag the export as a backup so the downloaded
                // file is named _BAK_UNLD instead of _FIX, making its origin clear to the user.
                if (backupAction) {
                    request.actionType = "backup";
                    request.backupAction = backupAction;
                }
                return companyReportApi.companyReportExportForeign(request, 'cwk')
                    .then(response => {
                        this.isExporting = false;
                    })
                    .catch(error => {
                        this.isExporting = false;
                        this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                    });
            },
            showLocalSheetsCommentsDialog() {
                (this.$refs.sheetsCommentsDialog as any).showDialog('cwk', 1, this.companyReport);
            },
            showForeignSheetsCommentsDialog() {
                (this.$refs.sheetsCommentsDialog as any).showDialog('cwk', 2, this.companyReport);
            }
        },
        setup() {
            return {v$: useVuelidate()};
        },
        validations() {
            //
        }
    });
</script>
